<template>
  <Card :class="{ 'blackBackGroup': isActive, 'blackBackGroup2': !isActive }">
   
        <div class="skill-set-bar">
          <Select v-model="selectedSkillSetId" size="small" style="width: 150px" placeholder="选择套装" @on-change="onSkillSetChange">
            <Option v-for="set in skillSetList" :key="set.setId" :value="set.setId">{{ set.setName }}</Option>
          </Select>
          <Input v-model.trim="skillSetName" size="small" style="width: 120px" maxlength="20" placeholder="套装名" />
          <Button size="small" ghost @click="newSkillSetDraft">新建</Button>
          <Button size="small" type="primary" ghost @click="saveSkillSet">保存</Button>
          <Button size="small" type="success" ghost @click="switchSkillSet">切换</Button>
          <Button size="small" ghost @click="renameSkillSet" :disabled="!selectedSkillSetId">重命名</Button>
          <Button size="small" type="error" ghost @click="deleteSkillSet" :disabled="!selectedSkillSetId">删除</Button>
        </div>
        <!-- 主动技能区域 -->
        <div class="skill-section">
          <h4 class="section-title">
            神通 <span class="slot-count">{{ activeEquippedCount }}/5</span>
          </h4>
          <div class="skill-grid active-grid">
            <div
              v-for="slot in 5"
              :key="'active-'+slot"
              class="skill-slot"
              :class="{
                'empty': !getEquippedSkill(slot),
                'filled': getEquippedSkill(slot),
                'dark': isActive,
                'drag-over': dragOverSlot === slot,
                'dragging': dragSlot === slot
              }"
              :draggable="!!getEquippedSkill(slot)"
              @dragstart="onDragStart($event, slot)"
              @dragend="onDragEnd"
              @dragover.prevent="onDragOver($event, slot)"
              @dragleave="onDragLeave(slot)"
              @drop="onDrop($event, slot)"
            >
              <!-- 有技能时显示 Poptip -->
              <template v-if="getEquippedSkill(slot)">
                <Poptip
                  trigger="hover"
                  transfer
                  placement="bottom"
                  :class-name="isActive ? 'dark-skill-popper' : ''"
                >
                  <!-- 触发元素：整个槽位内容 -->
                  <div class="slot-content" @click="handleSlotClick(slot)">
                    <span class="skill-name">{{ getEquippedSkill(slot).skillName }}</span>
                  </div>
                  
                  <!-- 悬浮内容 -->
                  <div slot="content" class="skill-popper-content">
                    <div class="skill-header">
                      <span class="skill-title" :style="{ color: getEquippedSkill(slot).color }">
                        {{ getEquippedSkill(slot).skillName }}
                      </span>
                      <Tag size="small" :color="getOrderColor(getEquippedSkill(slot).skillOrder)">
                        {{ distinguishColor(getEquippedSkill(slot).skillOrder) }}号位
                      </Tag>
                    </div>
                    
                    <div class="skill-basic">
                      <div class="info-row">
                        <span class="info-label">类型</span>
                        <span class="info-value">{{ baibaoReturnType(getEquippedSkill(slot).skillType) }}</span>
                      </div>
                      <div class="info-row">
                        <span class="info-label">冷却</span>
                        <span class="info-value">{{ getEquippedSkill(slot).cooling }}回合</span>
                      </div>
                    </div>
                    
                    <div class="skill-desc" v-if="getEquippedSkill(slot).skillDesc">
                      <div class="desc-title">
                       神通效果
                      </div>
                      <div class="desc-content">{{ getEquippedSkill(slot).skillDesc }}</div>
                    </div>
                    
                    <div class="skill-next" v-if="getEquippedSkill(slot).skillNextDesc && getEquippedSkill(slot).charaLevel !== null">
                      <div class="desc-title">下一级效果</div>
                      <div class="desc-content">{{ getEquippedSkill(slot).skillNextDesc }}</div>
                    </div>

                    <!-- 升级需求 -->
                    <div class="upgrade-info" v-if="getEquippedSkill(slot).charaLevel !== null">
                      <div class="desc-title"> 升级要求</div>
                      <div class="upgrade-item">
                        <span class="upgrade-label">人物等级</span>
                        <span class="upgrade-value" :class="{ 'met': userLevel >= getEquippedSkill(slot).charaLevel, 'unmet': userLevel < getEquippedSkill(slot).charaLevel }">
                          Lv.{{ getEquippedSkill(slot).charaLevel }} {{ userLevel >= getEquippedSkill(slot).charaLevel ? '✓' : '✗' }}
                        </span>
                      </div>
                      <div class="upgrade-item">
                        <span class="upgrade-label">消耗灵石</span>
                        <span class="upgrade-value" :class="{ 'met': userCoin >= getEquippedSkill(slot).consumeCoin, 'unmet': userCoin < getEquippedSkill(slot).consumeCoin }">
                          {{ formatNumber(getEquippedSkill(slot).consumeCoin) }} {{ userCoin >= getEquippedSkill(slot).consumeCoin ? '✓' : '✗' }}
                        </span>
                      </div>
                      <div class="upgrade-item" v-if="getEquippedSkill(slot).consumeMatNum">
                        <span class="upgrade-label">消耗碎片</span>
                        <span class="upgrade-value">{{ getEquippedSkill(slot).consumeMatName || '技能碎片' }} × {{ getEquippedSkill(slot).consumeMatNum }}</span>
                      </div>
                    </div>
                    
                    <div class="skill-actions">
                      <!-- <Button 
                        @click.stop="upgrade(getEquippedSkill(slot))" 
                        size="small" 
                        type="primary"
                        :disabled="!canUpgrade(getEquippedSkill(slot))"
                      >
                        升级
                      </Button> -->
                      <Button 
                        @click.stop="TakeSkill(getEquippedSkill(slot))" 
                        size="small" 
                        type="error" 
                        ghost
                      >
                        卸下
                      </Button>
                    </div>
                  </div>
                </Poptip>
              </template>
              
              <!-- 空槽位 -->
              <template v-else>
                <div class="empty-slot" @click="handleSlotClick(slot)">
                  <Icon type="ios-add" size="20" class="plus-icon" />
                </div>
              </template>
            </div>
          </div>
        </div>

        <!-- 被动符箓区域 -->
        <div class="skill-section">
          <h4 class="section-title">
            符箓 <span class="slot-count">{{ passiveEquippedCount }}/{{ passiveSlotTotal }}</span>
            <span class="sect-slot-tip">{{ hasSect ? '宗门符位已解锁' : '加入宗门解锁4-5号符位' }}</span>
          </h4>
          <div class="skill-grid passive-grid">
            <div 
              v-for="(item, index) in passiveList" 
              :key="'passive-'+index"
              class="skill-slot filled"
              :class="{ 'dark': isActive }"
            >
              <Poptip
                trigger="hover"
                transfer
                placement="bottom"
                :class-name="isActive ? 'dark-skill-popper' : ''"
              >
                <div class="slot-content" @click="handlePassiveSlotClick(index)">
                  <span class="skill-name">{{ item.skillName }}</span>
                </div>
                
                <div slot="content" class="skill-popper-content">
                  <div class="skill-header">
                    <span class="skill-title" :style="{ color: item.color }">{{ item.skillName }}</span>
                    <Tag size="small" color="default">被动</Tag>
                  </div>
                  <div class="skill-basic">
                    <div class="info-row">
                      <span class="info-label">类型</span>
                      <span class="info-value">{{ baibaoReturnType(item.skillType) }}</span>
                    </div>
                  </div>
                  <div class="skill-desc" v-if="item.skillDesc">
                    <div class="desc-title">符箓效果</div>
                    <div class="desc-content">{{ item.skillDesc }}</div>
                  </div>
                  <div class="skill-next" v-if="item.skillNextDesc && item.charaLevel !== null">
                    <div class="desc-title">下一级效果</div>
                    <div class="desc-content">{{ item.skillNextDesc }}</div>
                  </div>
                  <!-- 升级需求 -->
                  <div class="upgrade-info" v-if="item.charaLevel !== null">
                    <div class="desc-title"> 升级要求</div>
                    <div class="upgrade-item">
                      <span class="upgrade-label">人物等级</span>
                      <span class="upgrade-value" :class="{ 'met': userLevel >= item.charaLevel, 'unmet': userLevel < item.charaLevel }">
                        Lv.{{ item.charaLevel }} {{ userLevel >= item.charaLevel ? '✓' : '✗' }}
                      </span>
                    </div>
                    <div class="upgrade-item">
                      <span class="upgrade-label">消耗灵石</span>
                      <span class="upgrade-value" :class="{ 'met': userCoin >= item.consumeCoin, 'unmet': userCoin < item.consumeCoin }">
                        {{ formatNumber(item.consumeCoin) }} {{ userCoin >= item.consumeCoin ? '✓' : '✗' }}
                      </span>
                    </div>
                    <div class="upgrade-item" v-if="item.consumeMatNum">
                      <span class="upgrade-label">消耗碎片</span>
                      <span class="upgrade-value">{{ item.consumeMatName || '技能碎片' }} × {{ item.consumeMatNum }}</span>
                    </div>
                  </div>
                  <div class="skill-actions">
                    <!-- <Button 
                      @click.stop="upgrade(item)" 
                      size="small" 
                      type="primary"
                      :disabled="!canUpgrade(item)"
                    >
                      升级
                    </Button> -->
                    <Button @click.stop="TakeSkill(item)" size="small" type="error" ghost>
                      卸下
                    </Button>
                  </div>
                </div>
              </Poptip>
            </div>
            
            <!-- 空被动槽位 -->
            <div 
              v-for="emptyIdx in passiveEmptySlotCount" 
              :key="'empty-passive-'+emptyIdx"
              class="skill-slot empty"
              :class="{ 'dark': isActive, 'locked': isPassiveSlotLocked(passiveList.length + emptyIdx) }"
              @click="handlePassiveSlotClick(passiveList.length + emptyIdx - 1)"
            >
              <div class="empty-slot">
                <Icon :type="isPassiveSlotLocked(passiveList.length + emptyIdx) ? 'ios-lock' : 'ios-add'" size="20" class="plus-icon" />
                <span v-if="isPassiveSlotLocked(passiveList.length + emptyIdx)" class="locked-tip">宗门解锁</span>
              </div>
            </div>
          </div>
        </div>
      <!-- 未装备技能直接展示在符箓下方 -->
        <div class="unequipped-section">
          <h4 class="section-title">
            符箓库 <span class="count-badge">{{ skillList.length }}</span>
          </h4>
          
          <div class="filter-bar">
            <RadioGroup v-model="filterType" type="button" size="small">
              <Radio label="all">全部</Radio>
              <Radio label="0">道法</Radio>
              <Radio label="1">真气</Radio>
              <Radio label="2">天赋</Radio>
            </RadioGroup>
          </div>
          
          <div class="skill-list">
            <div 
              v-for="(item, idx) in filteredSkills" 
              :key="item.skillId"
              class="skill-item"
              :class="{ 'dark': isActive }"
            >
              <Poptip
                trigger="hover"
                transfer
                :placement="idx < 3 ? 'right' : 'left'"
                :class-name="isActive ? 'dark-skill-popper' : ''"
              >
                <!-- 触发元素：整个列表项 -->
                <div class="item-content" @click="handleUnequippedClick(item)">
                  <div class="item-info">
                    <span class="item-name" :style="{ color: item.color }">{{ item.skillName }}</span>
                  </div>
                  <div class="item-actions">
                    <Button 
                      v-if="item.skillType !== 2" 
                      @click.stop="openEquipModal(item)" 
                      size="small" 
                      type="primary" 
                      ghost
                    >
                      装备
                    </Button>
                    <Button 
                      v-else 
                      @click.stop="equipPassive(item)" 
                      size="small" 
                      type="primary" 
                      ghost
                    >
                      装备
                    </Button>
                    <Button 
                      @click.stop="upgrade(item)" 
                      size="small" 
                      type="info" 
                      ghost
                      :disabled="!canUpgrade(item)"
                    >
                      升级
                    </Button>
                  </div>
                </div>
                
                <!-- 悬浮内容 -->
                <div slot="content" class="skill-popper-content">
                  <div class="skill-header">
                    <span class="skill-title" :style="{ color: item.color }">{{ item.skillName }}</span>
                    <Tag v-if="item.skillType !== 2" size="small" :color="getOrderColor(item.skillOrder)">
                      {{ distinguishColor(item.skillOrder) }}号位
                    </Tag>
                    <Tag v-else size="small" color="default">被动</Tag>
                  </div>
                  <div class="skill-basic">
                    <div class="info-row">
                      <span class="info-label">类型</span>
                      <span class="info-value">{{ baibaoReturnType(item.skillType) }}</span>
                    </div>
                    <div class="info-row" v-if="item.cooling">
                      <span class="info-label">冷却</span>
                      <span class="info-value">{{ item.cooling }}回合</span>
                    </div>
                    <div class="info-row" v-if="item.charaLevel !== null">
                      <span class="info-label">等级</span>
                      <span class="info-value">Lv.{{ item.charaLevel }}</span>
                    </div>
                  </div>
                  <div class="skill-desc" v-if="item.skillDesc">
                    <div class="desc-title"> 神通效果</div>
                    <div class="desc-content">{{ item.skillDesc }}</div>
                  </div>
                  <div class="skill-next" v-if="item.skillNextDesc && item.charaLevel !== null">
                    <div class="desc-title"> 下一级效果</div>
                    <div class="desc-content">{{ item.skillNextDesc }}</div>
                  </div>
                  <!-- 升级需求 -->
                  <div class="upgrade-info" v-if="item.charaLevel !== null">
                    <div class="desc-title">升级要求</div>
                    <div class="upgrade-item">
                      <span class="upgrade-label">人物等级</span>
                      <span class="upgrade-value" :class="{ 'met': userLevel >= item.charaLevel, 'unmet': userLevel < item.charaLevel }">
                        Lv.{{ item.charaLevel }} {{ userLevel >= item.charaLevel ? '✓' : '✗' }}
                      </span>
                    </div>
                    <div class="upgrade-item">
                      <span class="upgrade-label">消耗灵石</span>
                      <span class="upgrade-value" :class="{ 'met': userCoin >= item.consumeCoin, 'unmet': userCoin < item.consumeCoin }">
                        {{ formatNumber(item.consumeCoin) }} {{ userCoin >= item.consumeCoin ? '✓' : '✗' }}
                      </span>
                    </div>
                    <div class="upgrade-item" v-if="item.consumeMatNum">
                      <span class="upgrade-label">消耗碎片</span>
                      <span class="upgrade-value">{{ item.consumeMatName || '技能碎片' }} × {{ item.consumeMatNum }}</span>
                    </div>
                  </div>
                </div>
              </Poptip>
            </div>
          </div>
        </div>

   <!-- 装备位置选择弹窗 -->
  <Modal v-model="equipModalVisible" title="选择装备位置" @on-ok="confirmEquip" :closable="false" width="520">
    <p class="modal-desc">
      <span v-if="willReplaceSlot">将替换 {{ willReplaceSlot.skillName }}，是否继续？</span>
      <span v-else>请选择要装备的位置（1-5号位）</span>
    </p>
    <div class="slot-selector">
      <div 
        v-for="slot in 5" 
        :key="slot"
        class="selector-slot"
        :class="{ 
          'occupied': isSlotOccupied(slot),
          'selected': selectedSlot === slot,
          'will-replace': isSlotOccupied(slot) && selectedSlot === slot
        }"
        @click="selectedSlot = slot"
      >
        <span class="slot-num">{{ slot }}</span>
        <div v-if="isSlotOccupied(slot)" class="slot-skill-name">
          {{ getEquippedSkill(slot).skillName }}
        </div>
        <Icon v-if="selectedSlot === slot" type="ios-checkmark-circle" :color="isSlotOccupied(slot) ? '#ff9900' : '#19be6b'" size="16" />
      </div>
    </div>
  </Modal>
  </Card>
</template>

<script>
export default {
  name: "skill",
  data() {
    return {
      willReplaceSlot: null,  // 新增：将要被替换的技能
      dragSlot: null,         // 正在被拖拽的槽位号
      dragOverSlot: null,     // 拖拽悬停的目标槽位号
      activeList: [],
      passiveList: [],
      skillList: [],
      filterType: 'all',
      equipModalVisible: false,
      selectedSkill: null,
      selectedSlot: 1,
      color: '#abb6c0',
      isActive: false,
      userLevel: 1, // 用户等级
      userCoin: 0, // 用户灵石
      hasSect: false,
      passiveSlotTotal: 5,
      skillSetList: [],
      selectedSkillSetId: '',
      skillSetName: '',
    };
  },
  computed: {
    activeEquippedCount() {
      return this.activeList.length;
    },
    passiveEquippedCount() {
      return this.passiveList.length;
    },
    passiveSlotLimit() {
      return this.hasSect ? this.passiveSlotTotal : 3;
    },
    passiveEmptySlotCount() {
      return Math.max(this.passiveSlotTotal - this.passiveList.length, 0);
    },
    filteredSkills() {
      if (this.filterType === 'all') return this.skillList;
      return this.skillList.filter(item => String(item.skillType) === this.filterType);
    }
  },
  created() {
    this.getUserInfo();
    this.getSectStatus();
    this.getEquipmentSkill(); // 初始显示已装备，需要调用一次
    this.getAllSkill();
    this.getSkillSetList();
    const theme = window.localStorage.getItem("isTheme");
    if (theme === "black") {
      this.isActive = true;
      this.color = '#373e57';
    } else {
      this.isActive = false;
      this.color = '#abb6c0';
    }
  },
  mounted() {
    this.$bus.$on("getSkillMsg", () => {
      this.getAllSkill();
      this.getEquipmentSkill();
      this.getSkillSetList();
      this.getSectStatus();
    });
    this.$bus.$on("userActivityUpdated", () => {
      this.getUserInfo();
      this.getSectStatus();
    });
  },
  beforeDestroy() {
    this.$bus.$off("getSkillMsg");
    this.$bus.$off("userActivityUpdated");
  },
  methods: {
    // ========== 拖拽交换神通位置 ==========
    onDragStart(e, slot) {
      this.dragSlot = slot;
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('text/plain', slot);
    },
    onDragEnd() {
      this.dragSlot = null;
      this.dragOverSlot = null;
    },
    onDragOver(e, slot) {
      this.dragOverSlot = slot;
    },
    onDragLeave(slot) {
      if (this.dragOverSlot === slot) {
        this.dragOverSlot = null;
      }
    },
    onDrop(e, slot) {
      this.dragOverSlot = null;
      const fromSlot = parseInt(e.dataTransfer.getData('text/plain'));
      if (!fromSlot || fromSlot === slot) return;

      const skillA = this.getEquippedSkill(fromSlot);
      const skillB = this.getEquippedSkill(slot);

      if (!skillA) return;

      if (skillB) {
        // 两个槽位都有技能 → 交换位置
        this.swapSkills(skillA, fromSlot, skillB, slot);
      } else {
        // 拖到空槽位 → 移动
        this.equipSkill(skillA, slot);
      }
    },
    swapSkills(skillA, slotA, skillB, slotB) {
      this.$http
        .post(`gameCharaSkill/makeSkill/?charaId=${this.getCookie("charaId")}&skillId=${skillA.skillId}&skillType=${skillA.skillType}&skillOrder=${slotB}`)
        .then(() => this.$http.post(`gameCharaSkill/makeSkill/?charaId=${this.getCookie("charaId")}&skillId=${skillB.skillId}&skillType=${skillB.skillType}&skillOrder=${slotA}`))
        .then(() => {
          this.$Notice.success({ title: "交换成功" });
          this.$bus.$emit("skillMsg1", "交换神通位置");
          this.getAllSkill();
          this.getEquipmentSkill();
          this.getSkillSetList();
        })
        .catch((err) => {
          this.$Notice.warning({ title: (err && err.data && err.data.msg) || "交换失败" });
          this.getAllSkill();
          this.getEquipmentSkill();
        });
    },
    // 获取用户信息（等级、灵石）
    getUserInfo() {
      const userActivity = JSON.parse(localStorage.getItem("userActivity") || "{}");
      this.userLevel = userActivity.level || 1;
      this.userCoin = userActivity.coin || 0;
    },
    getSectStatus() {
      const charaId = this.getCookie("charaId");
      if (!charaId) {
        this.hasSect = false;
        return;
      }
      this.$http
        .post(`/gameSect/sectBoundary/?charaId=${charaId}`)
        .then((res) => {
          this.hasSect = !!(res.data && res.data.data && res.data.data !== "无宗门");
        })
        .catch(() => {
          this.hasSect = false;
        });
    },
    // 格式化数字
    formatNumber(num) {
      if (!num) return '0';
      if (num >= 10000) return (num / 10000).toFixed(1) + '万';
      return num.toLocaleString();
    },
    // 判断是否可升级
    canUpgrade(item) {
      if (item.charaLevel === null) return false;
      return this.userLevel >= item.charaLevel && this.userCoin >= item.consumeCoin;
    },
    onSkillSetChange(setId) {
      const selected = this.skillSetList.find(item => item.setId === setId);
      this.skillSetName = selected ? selected.setName : '';
    },
    newSkillSetDraft() {
      this.selectedSkillSetId = '';
      if (!this.skillSetName) {
        const idx = (this.skillSetList ? this.skillSetList.length : 0) + 1;
        this.skillSetName = `套装${idx}`;
      }
      this.$Message.info("已切换为新建模式，点击保存将创建新套装");
    },
    getSkillSetList() {
      this.$http
        .post(`gameCharaSkill/getSkillSetList/?charaId=${this.getCookie("charaId")}`)
        .then((res) => {
          this.skillSetList = res.data.data || [];
          if (this.selectedSkillSetId) {
            const selected = this.skillSetList.find(item => item.setId === this.selectedSkillSetId);
            if (!selected) {
              this.selectedSkillSetId = '';
              this.skillSetName = '';
            }
          }
        })
        .catch(() => {
          this.skillSetList = [];
        });
    },
    saveSkillSet() {
      if (!this.skillSetName) {
        this.$Message.warning("请输入套装名称");
        return;
      }
      const payload = {
        charaId: this.getCookie("charaId"),
        setId: this.selectedSkillSetId || '',
        setName: this.skillSetName || '',
        activeSkills: this.activeList
          .filter(item => item.skillOrder)
          .map(item => ({ skillId: item.skillId, skillOrder: item.skillOrder })),
        passiveSkillIds: this.passiveList.map(item => item.skillId)
      };
      this.$http
        .post(`gameCharaSkill/saveSkillSet`, payload)
        .then((res) => {
          this.$Notice.success({ title: this.selectedSkillSetId ? "套装覆盖成功" : "新套装创建成功" });
          this.selectedSkillSetId = res.data.data || this.selectedSkillSetId;
          this.getSkillSetList();
        })
        .catch((err) => {
          this.$Notice.warning({ title: (err && err.data && err.data.msg) || "套装保存失败" });
        });
    },
    switchSkillSet() {
      if (!this.selectedSkillSetId) {
        this.$Message.warning("请先选择技能套装");
        return;
      }
      this.$http
        .post(`gameCharaSkill/switchSkillSet/?charaId=${this.getCookie("charaId")}&setId=${this.selectedSkillSetId}`)
        .then((res) => {
          this.$Notice.success({ title: res.data.msg || "切换成功" });
          this.getAllSkill();
          this.getEquipmentSkill();
        })
        .catch((err) => {
          this.$Notice.warning({ title: (err && err.data && err.data.msg) || "切换失败" });
        });
    },
    renameSkillSet() {
      if (!this.selectedSkillSetId) {
        this.$Message.warning("请先选择技能套装");
        return;
      }
      if (!this.skillSetName) {
        this.$Message.warning("请输入套装名称");
        return;
      }
      this.$http
        .post(`gameCharaSkill/renameSkillSet`, {
          charaId: this.getCookie("charaId"),
          setId: this.selectedSkillSetId,
          setName: this.skillSetName
        })
        .then((res) => {
          this.$Notice.success({ title: res.data.msg || "重命名成功" });
          this.getSkillSetList();
        })
        .catch((err) => {
          this.$Notice.warning({ title: (err && err.data && err.data.msg) || "重命名失败" });
        });
    },
    deleteSkillSet() {
      if (!this.selectedSkillSetId) {
        this.$Message.warning("请先选择技能套装");
        return;
      }
      this.$Modal.confirm({
        title: "删除技能套装",
        content: "确定删除当前套装吗？",
        onOk: () => {
          this.$http
            .post(`gameCharaSkill/deleteSkillSet/?charaId=${this.getCookie("charaId")}&setId=${this.selectedSkillSetId}`)
            .then((res) => {
              this.$Notice.success({ title: res.data.msg || "删除成功" });
              this.selectedSkillSetId = '';
              this.skillSetName = '';
              this.getSkillSetList();
            })
            .catch((err) => {
              this.$Notice.warning({ title: (err && err.data && err.data.msg) || "删除失败" });
            });
        }
      });
    },
    // 升级技能
    upgrade(item) {
      this.$http
        .post(
          "/gameCharaSkill/upgradeSkill?charaId=" +
            this.getCookie("charaId") +
            "&skillId=" +
            item.skillId
        )
        .then((res) => {
          if (!(res.data && res.data.status === 200)) {
            this.$Notice.warning({ title: (res.data && res.data.msg) || "升级失败" });
            return;
          }
          this.$Notice.success({ title: res.data.msg });
          this.getAllSkill();
          this.getEquipmentSkill();
          this.getUserInfo(); // 刷新用户信息
        })
        .catch((err) => {
          this.$Notice.warning({ title: "升级失败" });
        });
    },
    getEquippedSkill(slot) {
      return this.activeList.find(item => item.skillOrder === slot);
    },
    isSlotOccupied(slot) {
      return !!this.getEquippedSkill(slot);
    },
   // 点击槽位直接打开装备弹窗（支持替换）
    handleSlotClick(slot) {
      const existingSkill = this.getEquippedSkill(slot);
      
      // 如果有技能，打开弹窗准备替换；如果没技能，打开弹窗准备装备
      this.activeTab = 'unequipped';
      this.$Message.info(existingSkill ? `请选择替换 ${existingSkill.skillName} 的神通` : `请选择要装备到${slot}号位的神通`);
    },
    handlePassiveSlotClick(index) {
      if (this.passiveList[index]) return;
      if (this.isPassiveSlotLocked(index + 1)) {
        this.$Message.warning("加入宗门后可装配第4-5个符箓");
        return;
      }
      this.activeTab = 'unequipped';
      this.$Message.info('请选择要装备的被动符箓');
    },
    handleUnequippedClick(item) {
      if (item.skillType === 2) {
        this.equipPassive(item);
      } else {
        this.openEquipModal(item);
      }
    },
     // 打开装备弹窗 - 移除自动找空位的逻辑，默认选1号位
    openEquipModal(item) {
      this.selectedSkill = item;
      this.selectedSlot = 1;
      this.willReplaceSlot = this.getEquippedSkill(1);
      this.equipModalVisible = true;
    },
    
     // 确认装备 - 支持替换
    confirmEquip() {
      if (!this.selectedSkill || !this.selectedSlot) return;
      
      const occupiedSkill = this.getEquippedSkill(this.selectedSlot);
      
      // 如果槽位有技能，先卸下再装备（或者你的接口支持直接替换）
      if (occupiedSkill && occupiedSkill.skillId !== this.selectedSkill.skillId) {
        // 方案A：如果后端接口支持直接替换，直接调用 equipSkill
        // 方案B：如果需要先卸下，连续调用两个接口
        
        // 这里假设你的接口支持直接替换，直接装备即可
        this.equipSkill(this.selectedSkill, this.selectedSlot);
      } else {
        // 空槽位直接装备
        this.equipSkill(this.selectedSkill, this.selectedSlot);
      }
    },
     // 修改装备方法，移除槽位占用检查
    equipSkill(item, slot) {
      this.$http
        .post(`gameCharaSkill/makeSkill/?charaId=${this.getCookie("charaId")}&skillId=${item.skillId}&skillType=${item.skillType}&skillOrder=${slot}`)
        .then((res) => {
          this.$Notice.success({ title: res.data.msg });
          this.$bus.$emit("skillMsg1", "装备神通发送过来的");
          this.getAllSkill();
          this.getEquipmentSkill();
          this.getSkillSetList();
          this.activeTab = 'equipped';
          this.willReplaceSlot = null;
        })
        .catch((err) => {
          this.$Notice.warning({ title: err.data.msg });
        });
    },
    equipPassive(item) {
      if (this.passiveList.length >= this.passiveSlotLimit) {
        this.$Message.warning(this.hasSect ? "被动符箓槽已满，请先卸下其他符箓" : "加入宗门后可装配第4-5个符箓");
        return;
      }
      this.$http
        .post(`gameCharaSkill/makeSkill/?charaId=${this.getCookie("charaId")}&skillId=${item.skillId}&skillType=${item.skillType}&skillOrder=0`)
        .then((res) => {
          this.$Notice.success({ title: res.data.msg });
          this.$bus.$emit("skillMsg1", "装备符箓发送过来的");
          this.getAllSkill();
          this.getEquipmentSkill();
          this.getSkillSetList();
          this.activeTab = 'equipped';
        })
        .catch((err) => {
          this.$Notice.warning({ title: err.data.msg });
        });
    },
    TakeSkill(item) {
      this.$http
        .post(`gameCharaSkill/makeDownSkill/?charaId=${this.getCookie("charaId")}&skillId=${item.skillId}&skillType=${item.skillType}`)
        .then((res) => {
          this.$Notice.success({ title: "卸下成功" });
          this.$bus.$emit("skillMsg", "卸下神通发送过来的");
          this.getAllSkill();
          this.getEquipmentSkill();
          this.getSkillSetList();
        })
        .catch((err) => {
          this.$Notice.warning({ title: "卸下失败" });
        });
    },
    isPassiveSlotLocked(slot) {
      return slot > this.passiveSlotLimit;
    },
    getSkillIcon(type) {
      const map = { 0: 'ios-flame', 1: 'ios-bolt', 2: 'ios-snow' };
      return map[type] || 'ios-help-circle';
    },
    getOrderColor(order) {
      const colors = ['', 'blue', 'green', 'orange', 'red', 'purple', 'cyan', 'magenta', 'gold', 'lime'];
      return colors[order] || 'default';
    },
    distinguishColor(color) {
      const map = { 1: "壹", 2: "贰", 3: "叁", 4: "肆", 5: "伍", 6: "陆", 7: "柒", 8: "捌", 9: "玖", 10: "拾" };
      return map[color] || color;
    },
    baibaoReturnType(type) {
      const map = { 0: "道法", 1: "真气", 2: "天赋" };
      return map[type] || "其他";
    },
    getAllSkill() {
      this.$http
        .post(`gameCharaSkill/getCharaSkill/?charaId=${this.getCookie("charaId")}`)
        .then((res) => {
          this.skillList = res.data.data || [];
        })
        .catch((err) => {
          this.$Notice.warning({ title: err.data.msg });
        });
    },
    getEquipmentSkill() {
      this.$http
        .post(`gameCharaSkill/getCharaUseSkill/?charaId=${this.getCookie("charaId")}&skillType=1`)
        .then((res) => {
          this.activeList = res.data.data || [];
        })
        .catch((err) => {
          this.$Notice.warning({ title: err.data.msg });
        });
      this.$http
        .post(`gameCharaSkill/getCharaUseSkill/?charaId=${this.getCookie("charaId")}&skillType=2`)
        .then((res) => {
          this.passiveList = res.data.data || [];
        })
        .catch((err) => {
          this.$Notice.warning({ title: err.data.msg });
        });
    },
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return localStorage.getItem(name);
    }
  },
};
</script>

<style scoped>
* {
  font-family: '思源黑体', sans-serif;
}

.skill-tabs >>> .ivu-tabs-bar {
  border-bottom: 1px solid var(--border-color, #e8eaec);
  margin-bottom: 8px;
}

.skill-tabs >>> .ivu-tabs-tab {
  font-size: 12px;
  padding: 6px 10px;
}

.skill-tabs >>> .ivu-tabs-ink-bar {
  height: 2px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  color: var(--text-primary, #515a6e);
  margin-bottom: 6px;
}

.section-title .ivu-icon {
  color: #2d8cf0;
}

.slot-count {
  font-size: 10px;
  color: var(--text-secondary, #808695);
  margin-left: 2px;
}

.sect-slot-tip {
  margin-left: 6px;
  color: #8b6f2f;
  font-size: 10px;
  font-weight: 500;
}

.count-badge {
  background: #2d8cf0;
  color: white;
  padding: 1px 5px;
  border-radius: 8px;
  font-size: 10px;
  margin-left: 4px;
}

.skill-section {
  margin-bottom: 12px;
}

.skill-set-bar {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.skill-grid {
  display: grid;
  gap: 6px;
}

.active-grid {
  grid-template-columns: repeat(5, 1fr);
}

.passive-grid {
  grid-template-columns: repeat(5, 1fr);
}

.skill-slot {
  aspect-ratio: 1;
  border: 1px dashed var(--border-color, #dcdee2);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  background: var(--bg-card, #fff);
  min-height: 25px;
}

.skill-slot.dark {
  border-color: #373e57;
  background: #151728;
}

.skill-slot.empty {
  border-color: #c5c8ce;
}

.skill-slot.empty:hover {
  border-color: #2d8cf0;
  background: rgba(45, 140, 240, 0.05);
}

.skill-slot.locked {
  cursor: not-allowed;
  border-color: #d8b36a;
  background: rgba(216, 179, 106, 0.08);
}

.skill-slot.locked:hover {
  border-color: #d8b36a;
  background: rgba(216, 179, 106, 0.12);
}

.skill-slot.empty.dark:hover {
  border-color: #4975d4;
  background: rgba(73, 117, 212, 0.1);
}

.empty-slot {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 2px;
}

.locked-tip {
  color: #9a7a35;
  font-size: 9px;
  line-height: 1;
}

.plus-icon {
  color: #c5c8ce;
}

.skill-slot.empty:hover .plus-icon {
  color: #2d8cf0;
}

.skill-slot.filled {
  border-style: solid;
  border-color: #2d8cf0;
  background: linear-gradient(135deg, rgba(45, 140, 240, 0.1) 0%, rgba(45, 140, 240, 0.05) 100%);
}

.skill-slot.filled.dark {
  border-color: #4975d4;
  background: linear-gradient(135deg, rgba(73, 117, 212, 0.2) 0%, rgba(73, 117, 212, 0.1) 100%);
}

.slot-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 4px;
  width: 100%;
  height: 100%;
  justify-content: center;
  pointer-events: none; /* 让点击穿透到父元素 */
}

.slot-content .ivu-icon {
  color: #2d8cf0;
}

.skill-slot.dark .slot-content .ivu-icon {
  color: #4975d4;
}

.skill-name {
  font-size: 10px;
  font-weight: 500;
  color: var(--text-primary, #515a6e);
  text-align: center;
  line-height: 1.1;
  max-width: 95%;
 /* 关键修改：允许换行 + 省略号 */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;  /* 最多显示2行 */
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}

.skill-slot.dark .skill-name {
  color: #9c9cab;
}

.blackBackGroup >>> .skill-set-bar .ivu-select-selection,
.blackBackGroup >>> .skill-set-bar .ivu-input,
.blackBackGroup >>> .filter-bar .ivu-radio-group-button .ivu-radio-wrapper {
  background: #20263a !important;
  color: #e8edf8 !important;
  border-color: rgba(148, 163, 184, .36) !important;
}

.blackBackGroup >>> .skill-set-bar .ivu-select-placeholder,
.blackBackGroup >>> .skill-set-bar .ivu-select-selected-value,
.blackBackGroup >>> .skill-set-bar .ivu-input::placeholder {
  color: #aab4c8 !important;
}

.blackBackGroup >>> .filter-bar .ivu-radio-group-button .ivu-radio-wrapper-checked {
  background: #29456d !important;
  color: #f2f6ff !important;
  border-color: #4a83c9 !important;
}

/* trigger 必须覆盖整个区域 */
.slot-trigger {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  cursor: pointer;
}

.unequipped-section {
  padding: 4px 0;
}

.filter-bar {
  margin-bottom: 8px;
}

.filter-bar >>> .ivu-radio-group-button .ivu-radio-wrapper {
  padding: 0 8px;
  font-size: 11px;
}

.skill-list {
  display: flex;
  flex-wrap: wrap;          /* 允许换行 */
  flex-direction: row;      /* 横向排列（默认值，可省略） */
  gap: 6px;
  max-height: 300px;
  overflow-y: auto;
}

.skill-item {
  flex: 0 0 calc(33.333% - 4px);  /* 每行3个，减去gap的补偿 */
  /* 或者使用 width: calc(33.333% - 4px); */
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  border: 1px solid var(--border-color, #e8eaec);
  border-radius: 6px;
  background: var(--bg-card, #fff);
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
  box-sizing: border-box;   /* 确保padding和border不撑大元素 */
}

.skill-item:hover {
  border-color: #2d8cf0;
}

.skill-item.dark {
  border-color: #373e57;
  background: #151728;
}

.skill-item.dark:hover {
  border-color: #4975d4;
}

.item-icon {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background: rgba(45, 140, 240, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2d8cf0;
  flex-shrink: 0;
}

.item-info {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.item-name {
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

.item-actions {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

.item-actions .ivu-btn {
  padding: 0 6px;
  height: 22px;
  font-size: 10px;
}

.item-trigger {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  cursor: pointer;
}

.modal-desc {
  color: var(--text-secondary, #808695);
  margin-bottom: 12px;
  font-size: 12px;
}

.slot-selector {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
}

.selector-slot {
  aspect-ratio: 1;
  border: 1px solid var(--border-color, #e8eaec);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  background: var(--bg-card, #fff);
  padding: 4px;
}

.selector-slot:hover:not(.occupied) {
  border-color: #2d8cf0;
  background: rgba(45, 140, 240, 0.05);
}

.selector-slot.selected {
  border-color: #19be6b;
  background: rgba(25, 190, 107, 0.1);
}

.selector-slot.occupied {
  border-color: #ed4014;
  background: rgba(237, 64, 20, 0.05);
  cursor: not-allowed;
  opacity: 0.6;
}

.slot-num {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary, #515a6e);
}

/* ========== 悬浮框内容样式 ========== */
.skill-popper-content {
  padding: 8px;
  max-width: 320px;
}

.skill-header {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-bottom: 6px;
  border-bottom: 1px solid #e8eaec;
  margin-bottom: 6px;
}

.skill-title {
  font-size: 12px;
  font-weight: 600;
  flex: 1;
  word-break: break-all;
  line-height: 1.2;
}

.skill-basic {
  margin-bottom: 6px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 3px 0;
  font-size: 11px;
  border-bottom: 1px dashed #e8eaec;
}

.info-row:last-child {
  border-bottom: none;
}

.info-label {
  color: #808695;
}

.info-value {
  color: #515a6e;
  font-weight: 500;
}

.skill-desc,
.skill-next,
.upgrade-info {
  margin-bottom: 6px;
  padding: 6px;
  background: #f8f8f9;
  border-radius: 4px;
}

.upgrade-info {
  background: linear-gradient(135deg, #fff7e6 0%, #fff 100%);
  border: 1px solid #ffd591;
}

.desc-title {
  font-size: 10px;
  color: #808695;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 3px;
}

.desc-content {
  font-size: 11px;
  color: #515a6e;
  line-height: 1.4;
  word-break: break-all;
  white-space: pre-wrap;
}

.upgrade-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 3px 0;
  font-size: 11px;
  border-bottom: 1px dashed #ffd591;
}

.upgrade-item:last-child {
  border-bottom: none;
}

.upgrade-label {
  color: #fa8c16;
  font-weight: 500;
}

.upgrade-value {
  font-weight: 600;
  font-family: 'Roboto', sans-serif;
}

.upgrade-value.met {
  color: #19be6b;
}

.upgrade-value.unmet {
  color: #ed4014;
}

.skill-actions {
  display: flex;
  gap: 4px;
  padding-top: 6px;
  border-top: 1px solid #e8eaec;
}

.skill-actions .ivu-btn {
  flex: 1;
  height: 24px;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
}

/* 深色模式悬浮框 */
.dark-popper .ivu-poptip-inner {
  background: #1f2335 !important;
  border-color: #373e57 !important;
}

.dark-popper .skill-popper-content .skill-header,
.dark-popper .skill-popper-content .info-row,
.dark-popper .skill-popper-content .skill-actions {
  border-color: #373e57;
}

.dark-popper .skill-popper-content .skill-desc,
.dark-popper .skill-popper-content .skill-next {
  background: rgba(255, 255, 255, 0.05);
}

.dark-popper .skill-popper-content .upgrade-info {
  background: rgba(250, 140, 22, 0.1);
  border-color: #fa8c16;
}

.dark-popper .info-label,
.dark-popper .desc-title {
  color: #808695;
}

.dark-popper .info-value,
.dark-popper .desc-content {
  color: #9c9cab;
}

.dark-popper .upgrade-label {
  color: #fa8c16;
}
.slot-skill-name {
  font-size: 9px;
  color: #ed4014;
  max-width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 2px;
}

.selector-slot.will-replace {
  border-color: #ff9900;
  background: rgba(255, 153, 0, 0.1);
}

.selector-slot.occupied {
  opacity: 0.8;
  /* 移除 not-allowed，允许点击 */
}

.selector-slot.occupied:hover {
  border-color: #ff9900;
}

/* ========== 拖拽交换样式 ========== */
.skill-slot.dragging {
  opacity: 0.4;
}

.skill-slot.drag-over {
  border-color: #ff9900 !important;
  background: rgba(255, 153, 0, 0.15) !important;
  transform: scale(1.05);
  box-shadow: 0 0 8px rgba(255, 153, 0, 0.3);
}

.skill-slot.drag-over.dark {
  border-color: #ff9900 !important;
  background: rgba(255, 153, 0, 0.2) !important;
  box-shadow: 0 0 8px rgba(255, 153, 0, 0.4);
}
</style>

<style>
@media (max-width: 768px) {
  .slot-selector {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 10px !important;
    width: 100% !important;
  }

  .slot-selector .selector-slot {
    min-width: 0 !important;
    width: 100% !important;
    min-height: 82px;
  }

  .skill-list {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 8px !important;
    width: 100% !important;
  }

  .skill-slot,
  .skill-item {
    min-width: 0 !important;
    width: 100% !important;
  }

  .skill-name,
  .item-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .skill-set-bar {
    flex-wrap: wrap !important;
    gap: 6px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/skill.vue